var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8521 17.75V12.0833M15.75 13.9722L13.8785 12.0833L12.0071 13.9722M13.8502 8.30556V6.41667L8.23582 0.75H3.74433C2.69622 0.75 2.17216 0.75 1.77183 0.955879C1.41969 1.13697 1.1334 1.42593 0.953979 1.78135C0.75 2.1854 0.75 2.71435 0.75 3.77222V14.7278C0.75 15.7856 0.75 16.3146 0.953979 16.7187C1.1334 17.0741 1.41969 17.3631 1.77183 17.5441C2.17216 17.75 2.69622 17.75 3.74433 17.75H10.1073M8.23582 0.75V4.90556C8.23582 5.43449 8.23582 5.69896 8.33782 5.90099C8.42755 6.0787 8.57063 6.22318 8.74673 6.31373C8.94688 6.41667 9.20889 6.41667 9.73299 6.41667H13.8502M4.49291 13.9722H8.23582M4.49291 10.1944H10.1073M4.49291 6.41667H5.42864",
    stroke: "#636363",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDocument);
export default __webpack_public_path__ + "static/media/UploadDocument.7d596bd1cbbf6759f97017ea279c5069.svg";
export { ForwardRef as ReactComponent };